<template>
  <div class="container-fluid px-md-4">
    <div class="panel-heading my-2">
      <h2 class="text-left">Role Management</h2>
    </div>
    <form class="needs-validation px-2 pt-2" >
      <div class="form-group row mx-0 justify-content-end" :style="{ marginBottom: '1rem' }">
          <div class=" my-2 ">
          <button
              title="Add new"
              class="k-button k-secondary"
              @click="insert"
              type="button"
            >
              <i class="fa fa-plus mr-2" aria-hidden="true"></i>

              Add new
          </button>
        </div>
      </div>
    </form>
    <div class="example-wrapper" v-if="roles">
      <Grid
        ref="grid"
        :style="{ height: '55vh' }"
        :pageable="true"
        :skip= "skip"
        :data-items="result"
        :columns="columns"
        :take="take"
        :total="total"
        @pagechange="pageChangeHandler"
      >
        <template v-slot:myTemplate="{ props }">
          <custom :data-item="props.dataItem" @edit="edit" @remove="remove" />
        </template>
        <grid-toolbar class="text-left">
      
        </grid-toolbar>
        <grid-norecords> There is no data available custom </grid-norecords>
      </Grid>
      <dialog-container
        v-if="roleInEdit"
        :dialog-title="dialogTitle"
        :data-item="roleInEdit"
        @save="save"
        @editRole="editRole"
        @cancel="cancel"
      >
      </dialog-container>
    </div>
  </div>
</template>
<script>
import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
import { sampleRoles } from "./data";
import DialogContainer from "./DialogContainer";
import CommandCell from "./CommandCell";
import axios from "axios";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { oidcSettings } from "../../services/store";

export default {
  components: {
    Grid: Grid,
    "grid-toolbar": GridToolbar,
    "grid-norecords": GridNoRecords,
    "dialog-container": DialogContainer,
    custom: CommandCell,
    dropdownlist: DropDownList,
  },  
  props: {
    identity: {
      type: Object,
      default: null,
    }
  },
  data: function () {
    return {
      base_url: undefined,

      sort: [{ field: "roleName", dir: "asc" }],
      roles: undefined,
      roleInEdit: undefined,
      selectedIdentity: this.identity,
      identityPools: [],      
      skip: 0,
      take: 10,
      columns: [
        { field: "roleName", title: "Role Name" },

        { cell: "myTemplate", width: "150px" },
      ],
    };
  },
  beforeMount: function () {
    this.base_url = oidcSettings.authority + "/api/IdentityManagement/";
    if(this.selectedIdentity!=null)
    {
      this.getRoles();
    }
  },
  watch:{
    identity:function(){
      this.selectedIdentity=this.identity;
     this.getRoles();
    }
  },
  computed: {
    dialogTitle() {
      return `${
        this.roleInEdit.identityPoolID === undefined ? "Add" : "Edit"
      } role`;
    },
    result: {
            get: function() {
                return this.roles.slice(this.skip, this.take + this.skip);
            }
        },
    total () {
        return this.roles ? this.roles.length : 0;
    }
  },
  methods: {
     pageChangeHandler: function(event) {
        this.skip = event.page.skip;
        this.take = event.page.take;
  },
    async getRoles() {
      const client_id = oidcSettings.client_id;
      try {
        const response = await axios.get(
          this.base_url + "Role/GetRoles/"+this.selectedIdentity.id,
        );
        this.roles = response.data.result;
        console.log(this.roles);
      } catch (err) {
        console.log(err);
      }
    },
    edit(dataItem) {
      this.roleInEdit = this.cloneProduct(dataItem);
    },
    async remove(dataItem) {
      try {
        const client_id = oidcSettings.client_id;

        const response = await axios.delete(this.base_url + "Role/DeleteRole/"+dataItem.roleID+"/"+this.selectedIdentity.id);
        var roles = response.data.result;
        this.roles = this.roles.filter((p) => p.roleID !== dataItem.roleID);
        console.log(this.roles);
      } catch (err) {
        console.log(err);
      }
    },
    async editRole() {
      const dataItem = this.roleInEdit;
      const roles = this.roles.slice();

      let data = {
        //IdentityPoolID: this.selectedIdentity.id,
        RoleName: dataItem.roleName,
        RoleID: dataItem.roleID,
      };
      try {
        //const response = await axios.post("https://localhost:5001/api/User/AddUser", data);
        const response = await axios.put(
          this.base_url + "Role/UpdateRole/"+this.selectedIdentity.id,
          data
        );

        const index = roles.findIndex((p) => p.roleID === dataItem.roleID);
        roles.splice(index, 1, dataItem);
        //this.$router.push("/home");
      } catch (err) {
        console.log("Ooops!" + err);
      }

      this.roles = roles;
      this.roleInEdit = undefined;
    },
    async save() {
      const dataItem = this.roleInEdit;
      const roles = this.roles.slice();
        const client_id = oidcSettings.client_id;
      // let data = {
      //   //IdentityPoolID: this.selectedIdentity.id,
      //   IdentityPoolName:this.selectedIdentity.name,
      //   RoleName: dataItem.roleName,
      //   ClientID: client_id,
      // };
      try {
        //const response = await axios.post("https://localhost:5001/api/User/AddUser", data);
        const response = await axios
          .post(this.base_url + "Role/AddRole/"+dataItem.roleName+"/"+this.selectedIdentity.id)
          .then((response) => {
            var newObject = response.data.result;
            roles.push(newObject);
          });
        this.getRoles();
        //this.$router.push("/home");
      } catch (err) {
        console.log("Ooops!" + err);
      }

      this.roles = roles;
      this.roleInEdit = undefined;
    },

    cancel() {
      this.roleInEdit = undefined;
    },
    insert() {
      this.roleInEdit = {};
    },
    cloneProduct(product) {
      return Object.assign({}, product);
    },
    newRole(source) {
      const id =
        this.roles.reduce(
          (acc, current) => Math.max(acc, current.identityPoolID || 0),
          0
        ) + 1;
      const newRole = {
        identityPoolID: id,
        name: "",
      };

      return Object.assign(newRole, source);
    },
  },
};
</script>
<style >
.error {
  color: brown;
  margin: auto;
  text-align: left;
  padding: 5px;
}
</style>